<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>支社・支局／媒体詳細</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.branch.error."/>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>支社・支局／媒体名<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.branchName"
            hide-details
            placeholder="支社・支局／媒体名を入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>支社・支局／媒体名カナ</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.branchNameKana"
            hide-details
            placeholder="支社・支局／媒体名カナを入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goCompanytDetail">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goModify">変更する</mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goCompanytDetail" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>支社・支局／媒体削除</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          支社・支局／媒体を削除する場合は、以下のボタンをクリックしてください。
          <br>※関連するアカウント、アカウント申請が存在する場合は削除できません。
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <div>
          <mp-button red wide :disabled="!view.isDeletable" :disabledBtn="!view.isDeletable" @click.stop="dialog.deleteConfirm = true">削除する</mp-button>
        </div>
        <mp-dialog delete confirm :show="dialog.deleteConfirm" @clickOk="goDelete" @clickCancel="dialog.deleteConfirm = false"/>
        <mp-dialog delete :show="dialog.deleteComplete" @clickOk="goCompanytDetail" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { AdminMstBranch } from '@/api'
import MpLabel from '@/components/item/MpLabel'
import MpInputBox from '@/components/item/MpInputBox'
import MpError from '@/components/item/MpError'
import MpButton from '@/components/item/MpButton'
import MpDialog from '@/components/item/MpDialog'

export default {
  name: 'AdminMstBranchDetail',
  components: {
    MpLabel,
    MpInputBox,
    MpError,
    MpButton,
    MpDialog
  },
  data: () => ({
    companyId: null,
    view: {
      errors: [],
      isDeletable: false
    },
    form: {
      branchId: null,
      branchName: '',
      branchNameKana: ''
    },
    dialog: {
      modifyComplete: false,
      deleteConfirm: false,
      deleteComplete: false
    }
  }),
  methods: {
    goCompanytDetail () {
      this.$router.push({ path: `/admin/mst/company/detail/${this.companyId}` })
    },
    async goModify () {
      await AdminMstBranch.update(this.form)
        .then(() => { this.dialog.modifyComplete = true })
        .catch(error => { this.view.errors = error.messages })
    },
    async goDelete () {
      await AdminMstBranch.delete({ branchId: this.form.branchId })
        .then(() => { this.dialog.deleteComplete = true })
        .catch(error => {
          this.dialog.deleteConfirm = false
          this.view.errors = error.messages
        })
    }
  },
  created: async function () {
    const branchId = this.$route.params.id

    const result = await AdminMstBranch.detail({ branchId: branchId })
      .catch(error => {
        this.view.errors = error.messages
      })

    this.companyId = result.companyId
    this.view.isDeletable = result.isDeletable

    this.form = {
      branchId: branchId,
      branchName: result.branchName,
      branchNameKana: result.branchNameKana
    }
  }
}
</script>
